

































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import VueI18n from 'vue-i18n';
import VCreditCard from 'v-credit-card';
import ajax from '@/lib/ajax';
import Headerhome from '@/components/headerhome.vue';
import moment from 'moment';
import 'v-credit-card/dist/VCreditCard.css';
import { setInteractionMode } from 'vee-validate';
import Payment from '@/store/entities/order/payment';
import CreditCard from '@/store/entities/order/creditCard';
import AddOrder from '@/store/entities/order/addOrder';
import Customer from '@/store/entities/order/customer';
import FlightPayments from '@/store/entities/flight/flightPayment';
import Ajax from '../../lib/ajax'
import PaymentDialog from '@/components/paymentDialog.vue';
import Transfer from '@/store/entities/transfer/transfer';
@Component({
  components: {
    Headerhome,
    VCreditCard,
    PaymentDialog,
  },
})
export default class TransferPayment extends Vue {
    dialogContract: boolean = false;
  checkbox: boolean = false;
  hotelNote:string="";
  flightNote:string="";
  dialog: boolean = false;
  paymentDialog: boolean = false;
  errorMessages: string[] = [];
  creditCard: any={};
  flightPayment: FlightPayments = new FlightPayments();
  customer: Customer = new Customer();
  countryCode:any={};
  basketId: string;
  orderId:string="00000000-0000-0000-0000-000000000000";
  countries: any[] = [];
  transfer:Transfer=new Transfer();
  departureDate:string=null;
  hour:string=null;
  totalPax:number=0;
  customerGsm:string="";
  newPrice: string;
  $refs: {
    form: HTMLFormElement;
  };


      get getLanguage(){
   return this.$root.$i18n.locale;
  }

  get nowDate() {
    return moment(new Date()).format('DD-MM-yyyy');
  }


set currencyFormat(value) {
    this.newPrice = value;
  }
  get currencyFormat() {
    return this.$store.state.currency.id;
  }
  async emitDialog(e) {

this.paymentDialog=false;
const payload = {
  orderId: this.$store.state.payment.orderId,
};
const response = await ajax.post(
  'api/services/app/Booking/GetOrderById',
  payload
);
if(response.data.result.orderStatus==4){
  
  this.$router.push('/transferDetail/' + payload.orderId);
}else{

    this.$swal({
            icon: 'warning',
            title: 'Ödeme Hatası',
            text: 'Ödeme İşlemi Tamamlanamadı Lütfen Tekrar Deneyiniz',
            confirmButtonText: 'Tamam',
          })
}


}

 async created(){
  var currencyId  =window.location.href.split("?")[1].split("=")[1];

  this.$store.state.currency.id=currencyId;
  setInteractionMode('lazy');
  const payload = {
      ...this.$route.params,
      currencyId: this.currencyFormat
    };
    const response = await ajax.post(
      '/api/services/app/Transfer/AddBasket',
      payload
    );
    let basketId = response.data.result;
     await ajax
      .get('/api/services/app/Transfer/GetBasketById', {
        params: { id:basketId },
      }).then((result) => {
      this.flightPayment = result.data.result;
      

      this.transfer=result.data.result.transferItems[0].transfer;
      this.departureDate=result.data.result.transferItems[0].departureDate;
      this.hour=result.data.result.transferItems[0].hour;
      this.totalPax=result.data.result.transferItems[0].totalPax;
      this.basketId=basketId;
      })
      await ajax
      .get('/api/services/app/Content/GetCountries')
      .then((res) => (this.countries = res.data.result.items));
 
      if (this.flightPayment.currencyId !== this.currencyFormat) {

      this.priceFormatter(this.flightPayment.currencyId);
    } else {
      return;
    }

}
get totalPrice() {
  console.log("asdsd",this.flightPayment)
    return this.flightPayment.total + ' ' + this.flightPayment.currencyId;
  }
creditInfoChanged(values){
    this.creditCard=values;
 }

 async priceFormatter(currencyId) {

    const payload = {
      amount: this.flightPayment.total,
      firstCurrencyId: currencyId,
      secondCurrencyId: this.$store.state.currency.id,
    };
    console.log("pay",payload)
    const response = await ajax.post(
      '/api/services/app/Booking/ConvertExchangeRate',
      payload
    );
    this.flightPayment.total = response.data.result.total;
    this.flightPayment.currencyId = response.data.result.secondCurrencyId;

  }

  @Watch('currencyFormat', { immediate: true, deep: true })
  onChangeCurrencyFormat(price, oldPrice) {
    if (oldPrice === undefined) {
      return;
    } else if (oldPrice == undefined) {
      return;
    } else if (price !== oldPrice && oldPrice !== null && oldPrice !== '') {
      this.priceFormatter(oldPrice);
    }
  }

  

async saveOrder(e) {

   
    
this.errorMessages = [];
// this.$refs.form.validate().then(async (success) => {
//   if (!success) {
//     let errors = this.$refs.form.errors;
 

//     for (const [key, value] of Object.entries(errors)) {
    
//       if( value!=0){
       
//         this.errorMessages.push(
//         `${this.$i18n.t(key.toString())}: ${value}`
//       );
//       }
    
//     }
//     this.dialog = true;

//     return;
//   }


 this.paymentDialog = true;
  let addOrder = new AddOrder();
   addOrder.creditCard=new CreditCard();
  if(this.flightPayment.currencyId != 'RUB') {
 
  addOrder.creditCard.cardNumber = this.creditCard.cardNumber;
  addOrder.creditCard.cardOwner=this.creditCard.name;
  addOrder.creditCard.cvc=this.creditCard.security;
  
  let exprirations = this.creditCard.expiration.split('/');
  addOrder.creditCard.expiryMonth=exprirations[0];
  addOrder.creditCard.expiryYear=exprirations[1];
  }
  addOrder.customer = this.customer;
  addOrder.orderId=this.orderId;
  addOrder.flightNote=this.flightNote;
  addOrder.hotelNote=this.hotelNote;

  let fullGsm =this.countryCode.phoneCode + ' ' + this.customerGsm;

  addOrder.customer.gsm = fullGsm;
  addOrder.isWeb = true;
  addOrder.payment = {
    hostAddress: 'charterscanners.com',
    paymentType: 'creditCard',
    paymentTotal: this.flightPayment.total,
  };
  addOrder.transferId=this.$route.params.transferId;
 
  addOrder.requestId = this.$route.params.searchId;
 
  if(localStorage.currency==null){
        addOrder.currency = { id: this.flightPayment.currencyId };  
      }
      else{
        addOrder.currency = { id: this.flightPayment.currencyId };
      }

  addOrder.basket = { id: this.basketId };
  const response = await Ajax.post(
        '/api/services/app/Transfer/AddOrder',addOrder
      );
this.orderId=response.data.result.orderId;
this.$store.state.payment.response=response.data.result.response;
this.$store.state.payment.orderId=this.orderId;

}


}
